export const DEFAULT_ASSET_DISPLAY_NAME = 'Assets';
